import slugify from 'slugify';

import { CollectionTypes, URI } from '~/types/adamTypes';

import { dataSave } from '~/lib/data/save';

import type { NomadDB } from '~/db/NomadDB';

export const dataImportCommon = (db: NomadDB, nomadFetch: Function) => {
  const { saveCollectionItems } = dataSave(db);

  const importTrophies = async () => {
    let { result } = await nomadFetch(URI.Trophies);
    result = result.thisYear.map((item) => {
      return { ...item, collection: 'thisYear' };
    });
    await saveCollectionItems(CollectionTypes.Trophies, result);
  };

  const importRecommendations = async (isAdaptiveEnabled: boolean) => {
    let result = [];
    if (isAdaptiveEnabled) {
      const request = await nomadFetch(URI.Recommendations);
      result = request.result;
    }

    await saveCollectionItems(CollectionTypes.Recommendations, result, false, {
      isAdaptiveEnabled,
    });
  };

  const importRecommendationParameters = async (isAdaptiveEnabled: boolean) => {
    let result = [];
    if (isAdaptiveEnabled) {
      const request = await nomadFetch(URI.MemberRecommendationParameters);
      result = request.result;
      result = result.map((item) => {
        if (item.member) delete item.member;
        return { ...item, local: 0 };
      });
    }
    await saveCollectionItems(
      CollectionTypes.RecommendationParameters,
      result,
      true,
      {
        isAdaptiveEnabled,
      }
    );
  };

  const importProgressions = async () => {
    let { result } = await nomadFetch(URI.Progressions);
    result = result.map((item) => {
      return { ...item, local: 0 };
    });
    await saveCollectionItems(CollectionTypes.Progressions, result);
  };

  const importCoachingStats = async () => {
    let { result } = await nomadFetch(URI.CoachingStats);

    result = result.map((item) => {
      const appId: string = item.appId ?? '';
      return {
        ...item,
        appId,
        local: 0,
        total: item.isTotal ? 1 : 0,
        historyDateUTC: item.historyDateUTC
          ? item.historyDateUTC
          : item.historyDate,
      };
    });

    await saveCollectionItems(CollectionTypes.CoachingStats, result);
  };

  const importAssessments = async () => {
    const { result } = await nomadFetch(URI.Assessments);

    await saveCollectionItems(CollectionTypes.Assessments, result, true);
  };

  const importChallenges = async (isAdaptiveEnabled: boolean) => {
    let result = [];
    // Challenges has been disabled for the moment
    // if (isAdaptiveEnabled) {
    //   const request = await nomadFetch(URI.Challenges);
    //   result = request.result;
    // }

    result = result.map((item) => {
      return { ...item, slug: slugify(item.title, { lower: true }) };
    });
    await saveCollectionItems(CollectionTypes.Challenges, result);
  };

  const importLibrary = async () => {
    const { result } = await nomadFetch(URI.Library);
    await saveCollectionItems(CollectionTypes.Library, result);
  };

  const importLibraryBooks = async () => {
    const { result } = await nomadFetch(URI.LibraryBooks);
    await saveCollectionItems(CollectionTypes.LibraryBooks, result);
  };

  const importMediaCommon = async () => {
    let { result } = await nomadFetch(URI.Media, {
      params: {
        purpose: 'allExceptContent',
      },
    });
    result = result.map((item) => {
      return { ...item, libraryBookId: '' };
    });

    await saveCollectionItems(CollectionTypes.Media, result);
  };

  return {
    importCoachingStats,
    importTrophies,
    importProgressions,
    importChallenges,
    importLibrary,
    importLibraryBooks,
    importAssessments,
    importMediaCommon,
    importRecommendations,
    importRecommendationParameters,
  };
};
